import React, { FC } from "react";
import { TypographyProps } from "@mui/material/Typography/Typography";
import { BoxProps } from "@mui/material/Box/Box";
import { Box, Typography } from "@mui/material";
import Tooltiper from "components/Tooltiper";


interface Props {
  label: string,
  value: string | number | React.ReactNode,
  ValueProps?: TypographyProps
  fullWidth?: boolean
  vertical?: boolean // Для вертикальной компоновки (заголовок сверху, значение снизу)
  Props?: BoxProps
}

const CardField: FC<Props> = ({ label, value, ValueProps, fullWidth, vertical, Props }: Props) => {
  const isStringOrNumber = typeof value === 'string' || typeof value === 'number';
  
  // Вертикальная компоновка (заголовок сверху, значение снизу)
  if (vertical) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          gap: 0.5,
          ...(Props?.sx && { ...Props?.sx })
        }}
      >
        <Typography
          variant={"caption"}
          color={"text.secondary"}
          sx={{
            fontWeight: 500,
            lineHeight: 1.4
          }}
        >
          {label}
        </Typography>

        {isStringOrNumber ? (
          <Box sx={{ minWidth: 0, width: "100%" }}>
            <Typography
              component="span"
              variant="body2"
              {...ValueProps}
              sx={{
                fontWeight: 500,
                lineHeight: 1.6,
                display: "block",
                wordBreak: "break-word",
                overflowWrap: "break-word",
                ...(ValueProps?.sx && { ...ValueProps?.sx })
              }}
            >
              {value}
            </Typography>
          </Box>
        ) : (
          <Box sx={{ minWidth: 0 }}>
            {value}
          </Box>
        )}
      </Box>
    );
  }
  
  // Горизонтальная компоновка (заголовок слева, значение справа)
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        gap: 3,
        minHeight: "24px",
        ...(Props?.sx && { ...Props?.sx })
      }}
    >
      <Typography
        variant={"caption"}
        color={"text.secondary"}
        sx={{
          fontWeight: 500,
          lineHeight: 1.4,
          whiteSpace: "nowrap",
          flexShrink: 0
        }}
      >
        {label}
      </Typography>

      <Box sx={{ flex: 1, minWidth: 0, display: "flex", justifyContent: "flex-end" }}>
        {isStringOrNumber ? (
          <Box sx={{ minWidth: 0, width: "100%", display: "flex", justifyContent: "flex-end" }}>
            <Tooltiper
              text={String(value)}
              props={{
                variant: "body2",
                component: "span",
                sx: {
                  fontWeight: 500,
                  lineHeight: 1.6,
                  display: "block",
                  textAlign: "right",
                  width: "100%",
                  ...(ValueProps?.sx && { ...ValueProps?.sx })
                },
                ...ValueProps
              }}
            />
          </Box>
        ) : (
          <Box sx={{ minWidth: 0, width: "100%", display: "flex", justifyContent: "flex-end" }}>
            {value}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default CardField;